import { Box, Button, IconButton } from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import CancelIcon from "@material-ui/icons/Cancel";
import React, { useRef, useState, useEffect } from "react";

const EstimationUploadBtn = ({
  setGetImageData,
  setGetLength,
  accept = ".png,.jpeg,.jpg,.webp,.svg",
}) => {
  const ref = useRef();
  const [selectedImages, setSelectedImages] = useState([]);

  const handleImageData = async (event) => {
    const fileListArray = Array.from(event.target.files);
    const newImages = fileListArray.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));

    setSelectedImages((prevImages) => [...prevImages, ...newImages]);
    event.target.value = null;

    const formData = new FormData();
    newImages.forEach((img) => formData.append("file", img.file));
    setGetImageData(formData);
  };

  const handleDeleteImage = (index) => {
    const updatedImages = selectedImages.filter((_, i) => i !== index);
    setSelectedImages(updatedImages);

    const formData = new FormData();
    updatedImages.forEach((img) => formData.append("file", img.file));
    setGetImageData(formData);
  };

  useEffect(() => {
    // Log the formData whenever it changes
    const formData = new FormData();
    selectedImages.forEach((img) => formData.append("file", img.file));
  }, [selectedImages]);

  return (
    <Box my={2} style={{ position: "relative" }}>
      <input
        type="file"
        ref={ref}
        style={{ display: "none" }}
        accept={accept || ".png,.jpeg,.jpg,.webp,.svg"}
        multiple
        onChange={handleImageData}
      />
      <Button
        variant="outlined"
        color="secondary"
        size="large"
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        style={{ borderRadius: "2vh" }}
        onClick={() => ref.current.click()}
      >
        <AddCircleOutlineIcon /> Add Photos
      </Button>

      <Box display="flex" flexWrap="wrap" mt={2}>
        {selectedImages.map((img, index) => (
          <Box
            key={index}
            position="relative"
            m={1}
            display="inline-block"
            borderRadius={1}
            style={{ border: "1px solid #dfe0e0" }}
          >
            <img
              src={img.preview}
              alt={`Selected ${index}`}
              style={{ height: "100px", width: "100px", objectFit: "cover" }}
            />
            <IconButton
              size="small"
              style={{
                position: "absolute",
                top: "0",
                right: "0",
                backgroundColor: "rgba(255, 255, 255, 0.7)",
              }}
              onClick={() => handleDeleteImage(index)}
            >
              <CancelIcon fontSize="small" />
            </IconButton>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default React.memo(EstimationUploadBtn);
